import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CompletedImg from '../../../assets/completed.svg';
import PuzzleImg from '../../../assets/puzzle.svg';
import Blockquote from '../../../components/Blockquote';
import Button from '../../../components/Button';
import Notification from '../../../components/Notification';
import useModal from '../../../hooks/useModal';
import { AuthStore } from '../../../providers/auth';
import { EnrollmentStore } from '../../../providers/enrollment';
import { PROFILE_ROUTE } from '../../../routes/types';
import { getAllNotifications } from '../../../services/notifications';
import {
  addOrRemoveDaysToGivenDate,
  COBRA_PERSONAS,
  DateFormats,
  formatDate,
  formatPrice,
} from '../../../utils/utils';
import BenefitElectionModal from '../BenefitElectionsModal/BenefitElectionsModal';

const EnrollmentSuccess = ({ setSubmitted }: any) => {
  const initialDate = new Date();
  const dueDate = new Date("2023-01-31 23:59:00");
  const notifications = getAllNotifications()
    .filter((x, idx) => x.title.includes('Evidence') || x.title.includes('Verify'))
    .map((e) => {
      if (e.date) {
        const date = formatDate(addOrRemoveDaysToGivenDate(new Date(), 30));

        if (e.title.includes('Verify')) {
          e.route = `${PROFILE_ROUTE.slice(0, 9)}familymembers`;
        }
        if (date) {
          e.date = date;
        }
      }
      return e;
    });

  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const { updatedCost } = useContext(EnrollmentStore) || {};

  const [
    showBenefitElectionsModal,
    handleShowBenefitElectionsModal,
    handleCloseBenefitElectionsModal,
  ] = useModal();

  return (
    <Container
      className={
        'cnd-custom-container-small my-12 px-0 px-lg-0 border-light-gray rounded-1'
      }
    >
      <Container className="d-flex flex-column px-10 py-11 px-lg-11">
        <Row>
          <Col className={'col-12 text-center'}>
            <h5 className="m-0">Annual Enrollment</h5>
          </Col>
          <Col className={'col-12 text-center mt-4'}>
            <span className="text-sub1 fw-light lh-xs">{`${
              !(COBRA_PERSONAS.indexOf(selectedPersona) > -1)
                ? 'Submitted! You are almost done'
                : 'Completed'
            }`}</span>
          </Col>
          <Col className={'col-12 text-center'}>
            <span className="text-sub1 fw-light lh-xs">
              {`${
                !(COBRA_PERSONAS.indexOf(selectedPersona) > -1)
                  ? 'You still have required actions below'
                  : ''
              }`}
            </span>
          </Col>
          <Col className={'col-12 text-center mt-7'}>
            <img
              src={
                !(COBRA_PERSONAS.indexOf(selectedPersona) > -1)
                  ? PuzzleImg
                  : CompletedImg
              }
              alt="puzzle-img"
            />
          </Col>
        </Row>
        <Row className={'mt-11 align-items-center'}>
          <Col className={'col-6 text-start'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span
                className={'text-start text-sub1 fw-normal lh-xs'}
              >
                Per-pay-period
              </span>
            </Container>
          </Col>
          <Col className={'col-6 text-end'}>
            <span
              className={'text-start text-fs-5 text-sub1 fw-normal lh-xs text-center text-lg-start fw-light'}
            >
              {formatPrice(updatedCost, 'en-US', {
                currency: 'USD',
                style: 'currency',
                minimumFractionDigits: 0,
              })}
            </span>
          </Col>
        </Row>
        <Row className={'border-top-light-gray mb-4 pt-4'}>
          <Col className={'col-6 text-start'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span className={'text-start text-sub1 fw-normal lh-xs'}>
                Before-Tax
              </span>
            </Container>
          </Col>
          <Col className={'col-6 text-end'}>
            <span
              className={'text-start text-caption fw-light'}
            >
              {formatPrice(updatedCost - 17.5, 'en-US', {
                currency: 'USD',
                style: 'currency',
                minimumFractionDigits: 2,
              })}
            </span>
          </Col>
        </Row>
        <Row className={'border-top-light-gray mb-4 pt-4'}>
          <Col className={'col-6 text-start'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span
                className={'text-start text-sub1 fw-normal lh-xs'}
              >
                After-Tax
              </span>
            </Container>
          </Col>
          <Col className={'col-6 text-end'}>
            <span
              className={'text-start text-caption fw-light'}
            >
              {formatPrice(17.5, 'en-US', {
                currency: 'USD',
                style: 'currency',
                minimumFractionDigits: 2,
              })}
            </span>
          </Col>
        </Row>
        <Row className={'border-top-light-gray py-4 justify-content-lg-between'}>
          <Col className={'col-6 col-lg-3'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span className={'text-sub1 fw-normal lh-xs text-start'}>
                Confirmation
              </span>
              <span
                className={'text-sub1 fw-light lh-xs text-start'}
              >
                14252120616
              </span>
            </Container>
          </Col>

          <Col className={'col-6 col-lg-3'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span className={'text-sub1 fw-normal lh-xs text-lg-start text-end'}>
                Submitted
              </span>
              <span className="text-sub1 fw-light lh-xs text-start">
                {formatDate(initialDate, DateFormats.LONG)}
              </span>
            </Container>
          </Col>

          <Col
            className={
              'd-flex flex-column-reverse flex-lg-column col-12 col-lg-3 mt-7 mt-lg-0'
            }
          >
            {!(COBRA_PERSONAS.indexOf(selectedPersona) > -1) && (
              <Button
                className={'ms-lg-13 mb-0 mb-lg-3 mt-3 mt-lg-0'}
                variant={'primary-outline'}
                size={'sm'}
                onClick={() => setSubmitted(false)}
              >
                Change Elections
              </Button>
            )}

            <BenefitElectionModal
              showBenefitElectionsModal={showBenefitElectionsModal}
              handleCloseBenefitElectionsModal={
                handleCloseBenefitElectionsModal
              }
            />
          </Col>
        </Row>
       
        <div className={'d-none d-lg-block mt-10'}>
          <Blockquote variant="primary">
            <div className={'mt-2 text-ligther-grey'}>
              You can make changes to this event until <strong>
                {formatDate(dueDate, DateFormats.LONG)}</strong>
            </div>
          </Blockquote>
        </div>
      </Container>

      <Container className="d-flex flex-column px-10 py-11 px-lg-11 border-top-light-gray">
        <Row>
          <Col className={'col-12 col-lg-9'}>
            <h5 className={'m-0 mb-7'}>For your records</h5>
            <span className={'fw-light text-sub1 lh-xs'}>
              There are multiple options for retaining a record of this
              transaction.
            </span>
          </Col>

          <Col
            className={
              'd-flex flex-column-reverse flex-lg-column col-12 col-lg-3 mt-7 mt-lg-0'
            }
          >            
            <a
              className={'text-decoration-none'}
              href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
              target={'_blank'}
              rel="noreferrer"
            >
              <Button
                leftIcon={light('file-download')}
                variant="primary-outline"
                className={'order-1 order-lg-3 w-100 mt-4 mt-lg-0'}
                size="sm"
              >
                Download/Print
              </Button>
            </a>
            <Button
              className={'order-1 order-lg-3 w-100 mt-4'}
              variant={'primary'}
              size={'sm'}
              onClick={handleShowBenefitElectionsModal}
            >
              Show Summary
            </Button>
          </Col>
        </Row>
      </Container>

      {!(COBRA_PERSONAS.indexOf(selectedPersona) > -1) && (
        <Row
          className={
            'flex-column px-10 py-11 px-lg-11 bg-white solid-salmon-border mx-0 border-bottom'
          }
        >
          <Col className={'col-12 px-0'}>
            <h5 className={'m-0 mb-7'}>Action Required</h5>
            <span className={'fw-light text-sub1 lh-xs'}>
              All of your elections are complete except the following:
            </span>
          </Col>

          {notifications.map((notification, idx) => (
            <Col className={`px-0 ${idx > 1 ? 'border-bottom' : ''}`}>
              <Notification
                className={'ps-0'}
                onClick={() => {}}
                variant={'default'}
                notificationData={notification}
              />
            </Col>
          ))}
        </Row>
      )}

      <Container
        className={'bg-white rounded-border-bottom px-10 py-11 px-lg-11'}
      >
        <Row className={'mx-0'}>
          <Col className={'col-12 px-0'}>
            <h5 className={'m-0'}>Things to consider</h5>
          </Col>

          <Col className={'col-12 px-0 mt-7'}>
            <span className={'fw-light text-sub1 lh-xs'}>
              If you do not change your elections, this coverage will remain in
              effect. You may refer to the Confirmation Number above for future
              inquiries. If you have any questions, contact the Service Center
              at <span className={'fw-normal text-sub1'}>123 555-1212.</span>
            </span>
          </Col>

          <Col className={'col-12 px-0 mt-10'}>
            <span className={'fw-light text-sub1 lh-xs'}>
              Note: These elections are valid based on your current status; If
              your status changes, your eligibility for benefits and their
              related costs may change.
            </span>
          </Col>

          <Col className={'col-12 px-0'}>
            <Row>
              <Col className={'col-12 d-flex align-items-center mt-7'}>
                <FontAwesomeIcon
                  className={'text-light-grey me-4'}
                  icon={light('check')}
                />
                <span className={'fw-normal text-sub1 lh-xs'}>
                  Confirmation Statement
                </span>
              </Col>

              <Col className={'col-12 ps-11 ms-1'}>
                <span className={'fw-light text-sub1 lh-xs'}>
                  You'll receive Confirmation Statement by mail reflecting your
                  benefits coverage, covered dependents and associated costs.
                </span>
              </Col>
            </Row>
          </Col>

          <Col className={'col-12 px-0'}>
            <Row>
              <Col className={'col-12 d-flex align-items-center mt-7'}>
                <FontAwesomeIcon
                  className={'text-light-grey me-4'}
                  icon={light('check')}
                />
                <span className={'fw-normal text-sub1 lh-xs'}>
                  Medical ID Cards
                </span>
              </Col>

              <Col className={'col-12 ps-11 ms-1'}>
                <span className={'fw-light text-sub1 lh-xs'}>
                  If you enrolled in medical coverage, you'll receive ID cards
                  if required that will reflect you and all eligible dependents
                  enrolled in coverage. Direct any questions about ID cards to
                  the carrier.
                </span>
              </Col>
            </Row>
          </Col>

          <Col className={'col-12 px-0'}>
            <Row>
              <Col className={'col-12 d-flex align-items-center mt-7'}>
                <FontAwesomeIcon
                  className={'text-light-grey me-4'}
                  icon={light('check')}
                />
                <span className={'fw-normal text-sub1 lh-xs'}>
                  Health Care Flexible Spending Account
                </span>
              </Col>

              <Col className={'col-12 ps-11 ms-1'}>
                <span className={'fw-light text-sub1 lh-xs'}>
                  You did not make an annual contribution for Health Care
                  Flexible Spending Account. Therefore you will not be a
                  participant in the Health Care Flexible Spending Account for
                  the new plan year.
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

const EnrollmentSuccessPage = ({ setSubmitted }: any) => {
  return <EnrollmentSuccess setSubmitted={setSubmitted} />;
};

export default EnrollmentSuccessPage;
